/*
*   List of Action IDs that should be passed from accreditation.reducer.js to settings.reducer.js
 */

export const IDS = {
    admAccountsClients: 'admAccountsClients',

    // components:
    admAccountsClientDetails:       'admAccountsClientDetails',


    //paths
    admAccountsClientsGrid:             'admAccountsClientsGrid',
    admAccountsClientExternalRolesGrid: 'admAccountsClientExternalRolesGrid',


    // states
    // app_administration_accounts: 'app.administration.accounts',

    // tab states:

    app_administration_accounts_clients:            'app.administration.accounts.clients',
    app_administration_accounts_clientDetails:      'app.administration.accounts.clientDetails',
};
